import { Button, Select } from "antd";
import Input from "antd/lib/input/Input";
import { useHistory } from "react-router-dom";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { Locale } from "../../utils";
import { getList } from "../../utils/http/dataProvider";
import { getUserInfo } from "../../utils/redux/reducers/User";

const i18n = Locale.getInstance();
const { Option } = Select;

const VideoListHeader = ({
  keyword,
  setKeyword,
  status,
  setStatus,
  categoryId,
  setCategoryId,
}) => {
  const router = useHistory();
  const user = useSelector((state) => getUserInfo(state));

  const { data: categoriesData } = useQuery(
    ["video-categories", user.token],
    () =>
      getList("video-category", {
        pagination: {
          perPage: 1000,
          page: 1,
        },
        sort: {
          field: "id",
          order: "desc",
        },
        token: user.token,
      })
  );

  const categories = categoriesData?.data ?? [];

  return (
    <div className="header">
      <div className="actions">
        <Button
          onClick={() => router.push("/main/videos/categories")}
          style={{ marginRight: 8 }}
        >
          {i18n.t("video.category.title")}
        </Button>
        <Button
          onClick={() => {
            router.push({
              pathname: `/main/videos/edit`,
            });
          }}
          type="primary"
        >
          {i18n.t("video.add")}
        </Button>
      </div>
      <div className="search">
        <Select
          style={{ width: 200, marginRight: 8 }}
          placeholder={i18n.t("course.selectCategory")}
          allowClear
          value={categoryId === 0 ? undefined : categoryId}
          onChange={(value) => setCategoryId(value || 0)}
        >
          {categories.map((cat) => (
            <Option key={cat.id} value={cat.id}>
              {i18n.getPropNameByLocale(cat, "name")}
            </Option>
          ))}
        </Select>
        <Select
          style={{ width: 150, marginRight: 8 }}
          placeholder={i18n.t("common.statusLabel")}
          allowClear
          value={status === undefined ? undefined : status}
          onChange={(value) => setStatus(value)}
        >
          <Option value={1}>{i18n.t("album.statusOnShelf")}</Option>
          <Option value={0}>{i18n.t("album.statusOffShelf")}</Option>
        </Select>
        <Input
          defaultValue={keyword}
          onChange={(e) => {
            setKeyword(e.target.value);
          }}
          placeholder={i18n.t("video.name")}
          style={{ width: 200, marginRight: 8 }}
        />
        <Button type="primary">{i18n.t("common.search")}</Button>
      </div>
    </div>
  );
};

export default VideoListHeader;

